import { render, staticRenderFns } from "./AddMerchantAgent.vue?vue&type=template&id=4e21296a"
import script from "./AddMerchantAgent.vue?vue&type=script&lang=js"
export * from "./AddMerchantAgent.vue?vue&type=script&lang=js"
import style0 from "./AddMerchantAgent.vue?vue&type=style&index=0&id=4e21296a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports